import React from 'react';
import { Modal } from 'Modal';
import { ExploreTheSiteIcon, GracewayLogo, SignInIcon } from 'igniter/Icons';
import { Grid, Cell } from 'react-foundation';

// DD: temporary modal during the launch period
export class RedirectModal extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isOpen: this.props.isOpen,
    };

    this.onClose = this.onClose.bind(this);
    this.handleLoginModal = this.handleLoginModal.bind(this);
  }

  handleLoginModal() {
    var user_session = new crashdown.UserSession();
    user_session.triggerLoginModal();
    this.onClose();
  }

  onClose() {
    this.setState({ isOpen: false })
    document.cookie = 'shown_graceway_modal=true; expires=Wed, 18 Dec 2025 12:00:00 UTC; path=/'
  }

  render() {
    const {
      loggedIn,
    } = this.props;

    const {
      isOpen,
    } = this.state;

    // header greeting
    var greeting = <React.Fragment>
      <h5>Looking for Graceway?</h5>
      <p>
        Graceway and Igniter Media have joined forces into one juggernaut of a site.
      </p>
    </React.Fragment>

    if(window.location.pathname.startsWith('/products')) {
      greeting = <React.Fragment>
        <h5>This <em>is</em> the page you're looking for, but...</h5>

        <p>
          Graceway Media has a new home <em>and</em> a new name! We're still the
          same team creating the same great media, but now we're doing it as
          Igniter Media.
        </p>
      </React.Fragment>
    }

    // right side option
    var accountOption = <Cell medium={30}>
      <div>
        <SignInIcon />
      </div>
      <strong>Login into Your Account</strong>
      <p>
        Use either your Igniter or Graceway login info, or create a new account.
      </p>
      <a onClick={this.handleLoginModal}>Login ></a>
    </Cell>

    if(loggedIn) {
      accountOption = <Cell medium={30}>
        <div>
          <ExploreTheSiteIcon />
        </div>
        <strong>Get Started Exploring</strong>
        <p>
          We changed a lot more than our name. Come see what's new!
        </p>
        <a href={Routes.igniter_root_path()}
           className='caret'
           onClick={() => this.onClose()}>
          Explore the Site
        </a>
      </Cell>
    }

    return (
      <Modal
        isOpen={isOpen}
        className='redirect-modal two-column'
        onRequestClose={this.onClose}
      >
        {greeting}

        <Grid className="grid-margin-x">
          <Cell medium={30}>
            <div>
              <GracewayLogo />
            </div>
            <strong>Where did Graceway go?</strong>
            <p>
              We didn't actually go anywhere, we just changed our name.
            </p>
            <a href='/graceway'
               className='caret'
               onClick={() => this.onClose()}>
              Learn more
            </a>
          </Cell>
          {accountOption}
        </Grid>
      </Modal>
    );
  }
}
